import { render, staticRenderFns } from "./popup-login-tips.vue?vue&type=template&id=56baf8c1&scoped=true&"
import script from "./popup-login-tips.vue?vue&type=script&lang=js&"
export * from "./popup-login-tips.vue?vue&type=script&lang=js&"
import style0 from "./popup-login-tips.vue?vue&type=style&index=0&id=56baf8c1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56baf8c1",
  null
  
)

export default component.exports